
export default {
  // Auth-related translations
  "sign_in": "サインイン",
  "sign_up": "サインアップ",
  "email_address": "メールアドレス",
  "password": "パスワード",
  "new_password": "新しいパスワード",
  "confirm_password": "パスワードの確認",
  "forgot_password": "パスワードをお忘れですか？",
  "reset_password": "パスワードのリセット",
  "verification_code": "認証コード",
  "enter_verification_code": "メールで送信された6桁のコードを入力してください",
  "passwords_dont_match": "パスワードが一致しません",
  "password_too_short": "パスワードは8文字以上である必要があります",
  "invalid_code": "無効または期限切れのコード",
  "invalid_code_format": "認証コードは6桁の数字である必要があります",
  "password_reset_success": "パスワードが正常にリセットされました",
  "send_reset_link": "仮パスワードを送信",
  "reset_link_sent": "リセットリンクがメールで送信されました",
  "temp_password_sent": "仮パスワードがメールで送信されました",
  "reset_link_error": "リセットリンクの送信に失敗しました。後でもう一度お試しください。",
  "email_delivery_not_configured": "メール配信が構成されていません。管理者に連絡してください。",
  "for_testing_use": "開発テストの場合、Supabase CLIまたはダッシュボードを使用してユーザーを管理できます",
  "processing": "処理中...",
  "back": "戻る",
  "verify_code": "認証コードを入力",
  "email_not_received": "メールを受け取っていませんか？",
  "leave_page_warning": "保存されていない変更があります。このページを離れますか？パスワードのリセット進行状況は失われます。",
  "reset_link_required": "パスワードをリセットするには有効なリセットリンクが必要です",
  // Rate limit messages
  "reset_rate_limit_exceeded": "メール送信制限を超えました。しばらく待ってから再試行してください。",
  "reset_rate_limit_message": "別の仮パスワードをリクエストする前に {{seconds}} 秒お待ちください。",
  "wait_before_retry": "再試行する前にお待ちください",
  // Temporary password messages
  "password_reset_required": "続行するにはパスワードを変更する必要があります",
  "temp_password_instructions": "仮パスワードを使用しています。新しいパスワードを作成してください。",
  
  // Username dialog related translations
  "create_username": "ユーザー名の作成",
  "username_required_description": "続行するにはユーザー名を作成してください。あなたのユーザー名は他のユーザーに表示されます。",
  "username": "ユーザー名",
  "username_placeholder": "ユーザー名を入力",
  "username_requirements": "ユーザー名には文字、数字、アンダースコアのみを含めることができます。",
  "save_username": "ユーザー名を保存",
  "username_taken": "このユーザー名はすでに使用されています。別のユーザー名をお試しください。",
  "username_set_success": "ユーザー名が正常に設定されました！",
  "username_set_error": "ユーザー名の設定に失敗しました。もう一度お試しください。",
  "auth_error": "認証エラー。もう一度サインインしてください。",
  "sign_in_success": "サインインに成功しました！",
  "sign_in_failed": "サインインに失敗しました",
  "completing_sign_in": "サインイン完了中...",
  "please_wait": "資格情報を確認中です。お待ちください。",
  "or_continue_with": "または次で続行",
  "or_with_email": "またはメールで",
  "continue_with_google": "Googleで続行",
  "dont_have_account": "アカウントをお持ちでないですか？",
  "already_have_account": "すでにアカウントをお持ちですか？",
  "magic_link_sent": "マジックリンクがメールに送信されました",
  "magic_link_error": "マジックリンクの送信に失敗しました。後でもう一度お試しください。",
  "send_magic_link": "マジックリンクを送信"
};
